







export default {
  name: 'Card',
  props: {
    value: {
      required: false
    },
    label: {
      required: false
    },
    horizontal: {
      required: false
    },
    subtext: {
      required: false
    }
  }
};
